import { Activity, WifiOff, AlertTriangle } from "lucide-react";
import { useEdgeSafeMode } from "@/lib/resilience/edgeSafeMode";

/**
 * RealtimeStatusPill — discrete status indicator. Only renders when
 * the system is degraded. Never blocks the UI.
 */
export function RealtimeStatusPill() {
  const s = useEdgeSafeMode();
  if (s.level === "normal") return null;
  const isHard = s.level === "hard";
  const Icon = !s.online ? WifiOff : isHard ? AlertTriangle : Activity;
  const label = !s.online
    ? "Sin conexión — usando snapshots"
    : isHard
    ? "Live systems stabilizing…"
    : "Modo eficiente activo";
  return (
    <div
      className="pointer-events-none fixed bottom-2 left-2 z-[9996] flex items-center gap-1.5 rounded-full border border-border/60 bg-background/85 px-2.5 py-1 text-[10px] font-bold text-foreground shadow-sm backdrop-blur"
      role="status"
      aria-live="polite"
    >
      <Icon className={`h-3 w-3 ${isHard ? "text-amber-500" : "text-primary"}`} />
      <span>{label}</span>
    </div>
  );
}
